export { default } from './AutoComplete.js';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/AutoComplete/index.js